export default __webpack_public_path__ + "static/media/nantes7.3cb6e794.jpg";